/*
  flexit-quick-add
  Botón "Agregar al carro" de las cards (snippets/flexit-product-card.liquid).
  Agrega 1 unidad por /cart/add.js y abre el aviso de carrito del tema
  (<cart-notification> del header), igual que el botón de la ficha.
  Se puede cargar desde varias secciones: el guard evita registrarlo dos veces.
*/
(function () {
  if (window.flexitQuickAdd) return;
  window.flexitQuickAdd = true;

  function setState(btn, state) {
    var label = btn.querySelector('[data-label]');
    if (!btn.dataset.idleLabel && label) btn.dataset.idleLabel = label.textContent;
    btn.setAttribute('data-state', state);
    btn.classList.toggle('loading', state === 'loading');
    if (!label) return;
    if (state === 'loading') label.textContent = 'Agregando…';
    else if (state === 'success') label.textContent = 'Agregado ✓';
    else if (state === 'error') label.textContent = 'No se pudo agregar';
    else label.textContent = btn.dataset.idleLabel;
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-flexit-quick-add]');
    if (!btn) return;
    ev.preventDefault();
    var state = btn.getAttribute('data-state');
    if (btn.disabled || state === 'loading') return;

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = new FormData();
    body.append('id', btn.getAttribute('data-variant-id'));
    body.append('quantity', '1');
    if (cart && cart.getSectionsToRender) {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }

    setState(btn, 'loading');
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    fetch(addUrl, {
      method: 'POST',
      body: body,
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          setState(btn, 'error');
          setTimeout(function () { setState(btn, 'idle'); }, 2200);
          return;
        }
        setState(btn, 'success');
        setTimeout(function () { setState(btn, 'idle'); }, 1600);
        if (cart && cart.renderContents && res.sections) {
          cart.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'flexit-quick-add', productVariantId: btn.getAttribute('data-variant-id'), cartData: res });
        }
      })
      .catch(function (err) {
        console.error('flexit quick add error', err);
        setState(btn, 'error');
        setTimeout(function () { setState(btn, 'idle'); }, 2200);
      });
  });
})();
